function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  "data-name": "Path 83",
  d: "M287.312,220.855c0,36.7-23.864,87.415-52.719,115.121-12.8,12.3-26.579,20.067-39.7,20.067a83.51,83.51,0,0,1-23.681-3.481,51.5,51.5,0,0,0-29.869,0,83.5,83.5,0,0,1-23.68,3.481c-13.746,0-28.228-8.529-41.541-21.871C48.1,306.113,25.244,256.765,25.244,220.854c0-52.983,31.695-84.994,61.5-92.72,14.276-3.7,30.841-1.317,44.219,2.164a100.251,100.251,0,0,0,42.224,1.81q4.239-.728,8.411-1.81c13.378-3.481,29.935-5.865,44.219-2.164C255.619,135.861,287.312,167.872,287.312,220.855Z",
  transform: "translate(-25.244 -51.053)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M234.593,335.972c-35.41,6.257-62.684,4.524-83.234-.453a83.018,83.018,0,0,1-62.682-70.705c-10.42-85.844,45.669-110.836,45.669-110.836,16.44,7.469,34.925,3.481,34.925,3.481-11.8-11.789,3.915-25.351,3.915-25.351a100.25,100.25,0,0,1-42.224-1.81c-13.378-3.481-29.943-5.865-44.219-2.164-29.8,7.727-61.5,39.738-61.5,92.721s49.738,135.188,92.418,135.188a83.511,83.511,0,0,0,23.681-3.481,51.5,51.5,0,0,1,29.869,0,83.507,83.507,0,0,0,23.681,3.481c13.121,0,26.9-7.764,39.7-20.067C234.593,335.973,234.595,335.975,234.593,335.972Z",
  transform: "translate(-25.244 -51.053)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M397.516,3.28s-7.359,51.3-46.117,66.229c-37.051,14.276-70.078-24.321-83.625-21.281a5.424,5.424,0,0,0-1.707.662.073.073,0,0,0-.029.015l.007-.029C266.5,47.493,281.358,3.237,319.513.337,358.271-2.607,379.362,15.054,397.516,3.28Z",
  transform: "translate(-122.601 -0.001)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M397.515,3.28s-23.548,28.7-56.663,28.7c-29.119,0-64.875,13.084-73.08,16.248-.986.375-1.567.611-1.707.662a.072.072,0,0,0-.029.015l.007-.029C266.5,47.493,281.357,3.237,319.512.337,358.27-2.607,379.361,15.054,397.515,3.28Z",
  transform: "translate(-122.6 -0.001)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_50",
  "data-name": "Ellipse 50",
  cx: 26.486,
  cy: 17.138,
  rx: 26.486,
  ry: 17.138,
  transform: "translate(205.154 175.457) rotate(-95.676)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M254.043,166.437c0,6.027-9.464,11.046-22.025,12.186-1.751.162-3.562.243-5.416.243-1.935,0-3.819-.088-5.637-.257-12.444-1.185-21.8-6.181-21.8-12.172Z",
  transform: "translate(-95.565 -67.294)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M251.186,75.208,231.06,105.776a167.969,167.969,0,0,1,3.657,20.318c.463,3.937.795,8.007.95,12.186-1.751.162-3.562.243-5.416.243-1.935,0-3.819-.088-5.637-.257-.162-4.18-.522-8.242-1.016-12.172a160.823,160.823,0,0,0-14.762-49.856,5.52,5.52,0,0,1,9.75-5.18,145.68,145.68,0,0,1,8.47,20.73l14.917-22.65a5.517,5.517,0,0,1,9.213,6.071Z",
  transform: "translate(-99.213 -26.951)",
  fill: "rgba(147,147,147,0.69)"
});

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "apple",
    xmlns: "http://www.w3.org/2000/svg",
    width: 274.915,
    height: 304.989,
    viewBox: "0 0 274.915 304.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3e52504a.svg";
export { ForwardRef as ReactComponent };